export default __webpack_public_path__ + "static/TCP_EXEC_ERIC_WAGNER_BW_WEB-b144044ed6dfbb1e576215b0e6759b90.jpg";